export default {
	"transSec.FailedToGetPaymentLink": "获取支付链接失败",
	"transSec.IDidntGetAPaymentToken": "没获取到支付token",
	"transSec.FailedToCreateAlipayPrepaidOrder": "创建支付宝预付单失败!",
	"transSec.FailedToGetPaymentInformation": "获取支付信息失败",
	"transSec.return": "返回",
	"transSec.AgreeAndContinue": "同意并继续",
	"transSec.NoProductsSelected": "未选择商品",
	"transSec.prompt": "提示",
	"transSec.UntieTheBindingForTheTimeBeing": "暂不解绑",
	"transSec.UnbindTheAccount": "解绑账号",
	"transSec.SorryThePriceHasChanged": "抱歉，价格已发生变化!",
	"transSec.SorryFailedToCreateOrder": "抱歉，创建订单失败！",
	"transSec.RepeatPurchasePrompts": "重复购买提示",
	"transSec.ignore": "忽略",
	"transSec.ViewOrders": "查看订单",
	"transSec.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "微信授权后可进入访问，请求授权中···",
	"transSec.MarketplaceConfirmOrderPagePaymentMethodClick": "商城确认订单页_支付方式点击",
	"transSec.MarketplaceafterAddress": "商城（地址后置）",
	"transSec.MarketplaceCashierPageOrderButton": "商城收银台页_下单按钮",
	"transSec.TheSystemIsDeserting": "系统开小差啦",
	"transSec.TheSystemIsDesertingPleaseTryAgainLater": "系统开小差啦，请稍后再试",
	"transSec.PaymentFailed": "支付失败!",
	"transSec.PaymentSuccessful": "支付成功",
	"transSec.PaidSuccessfullyJumping": "已支付成功，正在跳转中...",
	"transSec.Wechat": "微信",
	"transSec.FlowerStaging": "花呗分期",
	"transSec.AlipayScanCodeToPay": "支付宝扫码支付",
	"transSec.PleaseTryAgainIfTheQueryFails": "查询失败请重试",
	"transSec.IfThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation": "支付成功，请返回微信继续操作",
	"transSec.MarketplaceConfirmationOrderPagePaymentResultConfirmationPopUpWindow": "商城确认订单页_支付结果确认弹窗",
	"transSec.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "商城订单确认页_优惠券挽留弹窗_确认按钮",
	"transSec.AcceptAndUse": "收下并使用",
	"transSec.PickUpFailed": "领取失败",
	"transSec.NoPaymentResultDetected": "没有检测到支付结果",
	"transSec.IfYouHaveAlreadyPaidPleaseClickRefreshToQueryTheResults": "若已经支付 请点击刷新进行结果查询",
	"transSec.Repayment": "重新支付",
	"transSec.MallCashierPagePaymentConfirmationPopUpconfirmButton": "商城收银台页_支付确认弹窗_确认按钮",
	"transSec.flushed": "刷新",
	"transSec.MallOrderConfirmationPagePaymentResultConfirmationPopUpWindowCloseButton": "商城订单确认页_支付结果确认弹窗_关闭按钮",
	"transSec.divide": "分",
	"transSec.timeLimit": "期",
	"transSec.0HandlingFees": "0手续费",
	"transSec.Fee¥¥": "含手续费￥",
	"transSec.PerIssue": "/每期",
	"transSec.recommend": "推荐",
	"transSec.MarketplaceConfirmOrderPagecouponClick": "商城确认订单页_优惠券点击",
	"transSec.PleaseConfirmThatYouHaveReadAndAgree": "请确认您已阅读并同意",
	"transSec.UserServiceAgreement": "《用户服务协议》",
	"transSec.OfferSelected": "已选优惠",
	"transSec.OffersAreAvailable": "有可用优惠",
	"transSec.NoOffersAvailable": "无可用优惠",
	"transSec.AfterPaymentYouNeedToComeBackToConfirmThePaymentResultToEnsureThatThePurchaseContentIsSmoothlyDistributed": "支付后需要回来确认支付结果，确保购买内容顺利发放！",
	"transSec.PaymentAmount": "支付金额",
	"transSec.Coupons": "优惠券",
	"transSec.IHaveReadAndAgree": "已阅读并同意",
	"transSec.GotIt": "知道了",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付该订单请在【叫叫】公众号的订单物流中进行支付",
	"transSec.RequestPaymentIn": "请求支付中...",
	"transSec.MarketplaceOrderConfirmationPagecouponClick": "商城订单确认页_优惠券点击",
	"transSec.abandon": "放弃"
}